<template lang="html">
	<div class="textarea">
		<label class="form-label">{{ label }}</label>
		<textarea
			class="form-control"
			:id="action + name"
			:rows="rows"
			:placeholder="placeholder"
			:value="model"
			@input="updateSelf($event.target.value)"
		>
		</textarea>
	</div>
</template>

<script>
export default {
	props: {
		name: {
			default: '',
		},
		label: {
			default: '',
		},
		id: {
			default: '',
		},
		rows: {
			default: 3,
		},
		model: {
			default: '',
		},
		action: {
			default: '',
		},
		placeholder: {
			default: undefined,
		},
	},
	methods: {
		updateSelf(model) {
			this.$emit('input', model);
		},
	},
};
</script>

<style lang="less" scoped>
.textarea {
	margin-top: 10px;
}
</style>
